import { gql } from '@apollo/client';
import { INSTITUTION } from './institution';
import { PEOPLE_PROFILE_INSTITUTION } from './peopleProfileInstitution';
import { PEOPLE_PROFILE_ORGANISATION } from './peopleProfileOrganisation';

export const PEOPLE_PROFILE = gql`
  fragment peopleProfile on PeopleProfile {
    id
    additionalInstitution
    beneficiaryType
    branch
    contactNumber
    dateExited
    dateOfBirth
    dateStarted
    designation
    disability
    disabilityTypes {
      id
      name
    }
    emailAddress
    emisNumber
    firstName
    ictSkill {
      id
      name
      value
    }
    leadEducator
    localMunicipality {
      id
      localMunicipality
    }
    districtMunicipality {
      id
      name
    }
    multiGrade
    name
    nationalID
    organisation
    otherRole
    ovc
    persalNumber
    postLevel
    prePrimaryExperience
    programmeName
    region {
      id
      name
    }
    serviceProviderName
    status
    trackingId
    lastName
    year
    careGiverName
    careGiverSurname
    careGiverGender {
      id
      name
    }
    careGiverNationalId
    careGiverMaritalStatus
    careGiverContactNumber
    careGiverRelationship
    careGiverEmailAddress
    careGiverPhysicalAddress
    careGiverOccupation
    careGiverEmployer
    careGiverType
    yearsInGrade
    yearsInPhase
    yearsOfExperience
    personnelPositionOther
    privateToOrganisation
    caseId
    householdId
    householdCode
    age
    physicalAddress
    streetNo
    streetName
    townshipVillageSuburb
    townCity
    postalCode
    nextOfKinName
    nextOfKinSurname
    nextOfKinContactNumber
    nextOfKinAlternateContactNumber
    linkedToCommunity
    linkedToOrganisation
    attendance {
      id
      session {
        id
      }
      sunday
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
    }
    role {
      id
      name
    }
    communityType {
      id
      name
    }
    country {
      id
      name
    }
    district {
      id
      name
    }
    educatorLevel {
      id
      name
    }
    gender {
      id
      name
    }
    grades {
      id
      value
      name
    }
    highestQualification {
      id
      name
    }
    homeLanguage {
      id
      name
    }
    interventionRole {
      id
      name
    }
    natureOfEmployment {
      id
      name
    }
    personnelPosition {
      id
      name
    }
    phase {
      id
      name
    }
    populationGroup {
      id
      name
    }
    province {
      id
      name
    }
    reasonForTermination {
      id
      name
    }
    renumerationSource {
      id
      name
    }
    sessions {
      id
    }
    subjects {
      id
      name
      subjectGradeReference
    }
    type {
      id
      name
    }
    citizenship {
      id
      name
    }
    immunizationCard
    receivingSocialGrant
    accountPayer
    childResidesWithThisCaregive
    proofOfIncomeFile {
      id
    }
    roadToHealthCardFile {
      id
    }
    profileImage {
      id
    }
    monthlyIncomeRange
    monthlyIncome
    incomeSourceDocument
    grantType
    reasonExited
    birthCertificateOrId
    appliedForBirthCertificateOrId
    reasonForLackOfBirthCertificateOrId
    caregiverCitizenship {
      id
      name
    }
    caregiverIdentificationType
    caregiverPassport
    ageRange
    employmentStatus
    identificationType
    passport
    studyPermit
    studyPermitNumber
    reasonForLackOfRoadToHealthCard
    specialNeeds
    caregiverList {
      id
      careGiverContactNumber
      careGiverEmailAddress
      careGiverEmployer
      careGiverGender {
        id
        name
      }
      careGiverMaritalStatus
      careGiverName
      careGiverNationalId
      careGiverOccupation
      careGiverOccupationOther
      careGiverPhysicalAddress
      careGiverRelationship
      careGiverSurname
      careGiverType
      proofOfIncomeFile {
        id
      }
      roadToHealthCardFile {
        id
      }
      monthlyIncomeRange
      monthlyIncome
      incomeSourceDocument
      caregiverIdentificationType
      caregiverCitizenship {
        id
        name
      }
      caregiverPassport
      employmentStatus
      reasonExited
      childResidesWithThisCaregive
      accountPayer
    }
    associatedInstitutions {
      ...peopleProfileInstitution
    }
    associatedOrganisations {
      ...peopleProfileOrganisation
    }
    primaryInstitution {
      ...institution
    }
    institutions {
      ...institution
    }
  }
  ${INSTITUTION}
  ${PEOPLE_PROFILE_INSTITUTION}
  ${PEOPLE_PROFILE_ORGANISATION}
`;
